import {Component, OnInit} from '@angular/core';
import {Post} from "../../../../domain/post";
import {SelectItem} from "primeng/components/common/api";
import {PostService} from "../../../../service/forum/post.service";
import {ActivatedRoute, Router} from "@angular/router";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {AuthService} from "../../../../../core/security/auth.service";
import {Location} from '@angular/common';
import {TopicService} from "../../../../service/forum/topic.service";
import {User} from "../../../../../core/domain/user";

@Component({
    selector: 'app-post-form',
    templateUrl: './post-form.component.html',
    styleUrls: ['./post-form.component.scss'],
    providers: [PostService, TopicService]
})
export class PostFormComponent implements OnInit {

    public post : Post = null;
    public postForm: FormGroup;
    public title : string = "";
    public navTitle : string = "";
    public update : boolean = false;
    public user : User = null;
    public topics : SelectItem[] = [{label : "Seleccion un tópico", value : null}];
    public backRoute : string[] = ["../.."];

    constructor(private postService: PostService,
                private topicService: TopicService,
                private route: ActivatedRoute,
                private formBuilder: FormBuilder,
                private authService: AuthService,
                private location: Location,
                private router: Router) {

        this.postForm = this.formBuilder.group({
            id: [null],
            content: ['', Validators.required],
            title: ['', Validators.required],
            topic: ['', Validators.required]
        });
    }

    ngOnInit() {
        let id = this.route.params
            .map(params => params['id']);

        id.filter(id => id != 'new')
            .switchMap(id => this.postService.get(+id))
            .subscribe(post => {
                this.post = post;
                this.postForm.get("content").setValue(this.post.content);
                this.postForm.get("title").setValue(this.post.title);
                this.postForm.get("topic").setValue(this.post.topic);
                this.postForm.get("id").setValue(this.post.id);
                this.update = true;
                this.backRoute = [".."];
                this.title = "Editar el post";
                this.navTitle = "Volver al post";
            });

        id.filter(id => id == 'new')
            .subscribe(post => {
                this.post = new Post();
                this.update = false;
                this.title = "Nuevo post";
                this.navTitle = "Volver atras";
            });

        this.authService.user
            .subscribe(u => this.user = u);

        this.topicService.getAll()
            .map( t => t.map(topic => ({'label': topic.name, value : topic}) ))
            .subscribe(t => this.topics = this.topics.concat( t ) );
    }

    public formToEntity( value ) : Post {
        let p : Post = this.post;
        p.title = value.title;
        p.topic = value.topic;
        p.content = value.content;
        p.id = value.id;
        if ( !this.update ) {
            p.publishTime = new Date().getTime();
            p.user = this.user;
            p.likeCount = 0;
            p.replyCount = 0;
            p.postOpen = true;
        }
        return p;
    }

    public save( { value, valid } ) {
        let p : Post = this.formToEntity(value);
        if (!this.update){
            this.postService.create(p)
                .subscribe( p => this.router.navigate( [ "home", "post", p.id] ) );
        } else {
            this.postService.update(p)
                .subscribe( p => this.router.navigate( [ "home", "post", p.id] ) );
        }
    }

    public goBack() {
        this.location.back();
    }

}



// WEBPACK FOOTER //
// ./src/app/fiscalia/component/forum/post/post-form/post-form.component.ts